import { render, staticRenderFns } from "./PaidPlanChangeConfirmPage.vue?vue&type=template&id=21f27837&scoped=true"
import script from "./PaidPlanChangeConfirmPage.vue?vue&type=script&lang=ts"
export * from "./PaidPlanChangeConfirmPage.vue?vue&type=script&lang=ts"
import style0 from "./PaidPlanChangeConfirmPage.vue?vue&type=style&index=0&id=21f27837&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f27837",
  null
  
)

export default component.exports